"use client";

import { Datadog, type RumUserData } from "@yardzen/components/datadog";
import { useSession } from "next-auth/react";

/** RUM with the NextAuth session as its user. Needs a SessionProvider above. */
export function DatadogWithSession({ service }: { service: string }) {
  const { data: session, status } = useSession();

  // Leave identity alone while the session loads, so a logged-in user is not
  // briefly cleared on every page load.
  let userData: RumUserData | undefined;
  if (status === "authenticated" && session?.user) {
    userData = {
      email: session.user.email || undefined,
      userId: (session.user as { id?: string }).id || undefined,
    };
  } else if (status === "unauthenticated") {
    userData = null;
  }

  return <Datadog service={service} userData={userData} />;
}
